// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ycAHiu6qAuxZae {
  position: relative;
  width: 768px;
  height: 512px;
  margin-right: auto;
  margin-left: auto;
  overflow: hidden;
  border-radius: 3px;
  background-attachment: scroll;
  background-color: var(--ds-surface, #ffffff);
  background-repeat: no-repeat;
  background-size: contain;
  background-position-x: right;
  background-position-y: top;
}
.ycAHiu6qAuxZae > div {
  height: 100%;
}
.wwhk9D6xFe9IEF {
  position: absolute;
  z-index: 1;
  top: 0;
  right: 0;
}
.wwhk9D6xFe9IEF .ZpxrIlCAvSz8_y {
  margin: 6px;
}
.QlkhRrpK6nqveP {
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  min-height: 328px;
  margin-right: 50%;
  padding-left: 32px;
  overflow-y: auto;
}
.QlkhRrpK6nqveP .jvL60nCmKSRHxY {
  display: flex;
  flex-direction: column;
  overflow-y: auto;
}
.QlkhRrpK6nqveP .Cfrs9V0g46jf0k {
  margin-top: 30px;
}
.QlkhRrpK6nqveP .Cfrs9V0g46jf0k button {
  margin-right: 8px;
}
.lOaThwz6sksx2S {
  word-wrap: break-word;
}
.QSlRMjcKhLEgbW {
  padding-bottom: 16px;
}
.Wize58AgBr5Mwm {
  margin-top: 40px;
  color: var(--ds-text, #172b4d);
  font-size: 24px;
  letter-spacing: -0.01em;
  line-height: 28px;
  font-weight: var(--ds-font-weight-semibold, 600);
  margin: 0;
  overflow: hidden;
  font-weight: var(--ds-font-weight-medium, 500);
  text-overflow: ellipsis;
}
.RSeViEIJPtMcQr {
  position: absolute;
  top: 0;
  right: 0;
  max-width: 50%;
}
.PqNT7LzORlWo3h {
  display: none;
}
@media only screen and (max-width: 750px) {
  .ycAHiu6qAuxZae {
    width: 510px;
    max-width: 100vw;
    height: auto;
    min-height: 512px;
    padding: 0;
    /* stylelint-disable-next-line declaration-no-important */
    background-image: none !important;
  }
  .ycAHiu6qAuxZae > div {
    /* stylelint-disable-next-line declaration-no-important */
    margin: 0 !important;
  }
  .QlkhRrpK6nqveP {
    display: block;
    margin-right: 0;
    padding: 36px 24px;
  }
  .het1dLkVUEO4Uc {
    width: 100%;
    min-width: 375px;
  }
  .RSeViEIJPtMcQr {
    display: none;
  }
  .PqNT7LzORlWo3h {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 200px;
    overflow: hidden;
  }
}
.x6MwT_YZVsPfjQ {
  position: absolute;
  z-index: 100;
  top: 207px;
  right: 42px;
  width: 200px;
  padding: 28px 8px 28px 78px;
  overflow: hidden;
  border: 1px solid var(--ds-border, #091e4224);
  border-radius: 4px;
  background: var(--ds-surface, #ffffff);
  box-shadow: var(--ds-shadow-overlay, 0px 8px 12px #091e4226, 0px 0px 1px #091e424f);
  text-overflow: ellipsis;
}
.x6MwT_YZVsPfjQ .Gk1talRmKh95u9,
.x6MwT_YZVsPfjQ .Tjk6uv5GGaoP5f {
  max-width: 100%;
  margin-bottom: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.x6MwT_YZVsPfjQ .Gk1talRmKh95u9 {
  color: var(--ds-text, #172b4d);
  font-size: 16px;
  font-weight: var(--ds-font-weight-medium, 500);
  letter-spacing: 0.256px;
  line-height: 20px;
}
.x6MwT_YZVsPfjQ .Tjk6uv5GGaoP5f {
  color: var(--ds-text-subtle, #44546f);
  font-size: 12px;
  font-weight: var(--ds-font-weight-medium, 500);
  letter-spacing: 0.256px;
  line-height: 16px;
}
.x6MwT_YZVsPfjQ .ZjbAUhrBh9a8qm {
  position: absolute;
  top: 50%;
  left: 11px;
  margin-top: -28px;
}
.x6MwT_YZVsPfjQ .ZjbAUhrBh9a8qm > * {
  position: absolute;
  z-index: 1;
}
.x6MwT_YZVsPfjQ .ZjbAUhrBh9a8qm .XTC4dX1AY2uRjd {
  z-index: 2;
}
.uf0TiaJ47xu0YV {
  margin-top: 16px;
}
.uf0TiaJ47xu0YV button {
  margin-right: 16px;
}
.D6W4EGdpMVoEYI {
  display: inline-block;
  margin-left: 16px;
}
@media only screen and (max-width: 750px) {
  .x6MwT_YZVsPfjQ {
    top: 66px;
    right: 18%;
    left: 18%;
    width: auto;
    min-height: 30px;
    padding: 18px 8px 18px 78px;
  }
}
@media only screen and (max-width: 450px) {
  .x6MwT_YZVsPfjQ {
    right: 8%;
    left: 8%;
  }
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dialog": `ycAHiu6qAuxZae`,
	"controls": `wwhk9D6xFe9IEF`,
	"closeButton": `ZpxrIlCAvSz8_y`,
	"content": `QlkhRrpK6nqveP`,
	"description": `jvL60nCmKSRHxY`,
	"buttons": `Cfrs9V0g46jf0k`,
	"breakable": `lOaThwz6sksx2S`,
	"header": `QSlRMjcKhLEgbW`,
	"title": `Wize58AgBr5Mwm`,
	"illustrationFull": `RSeViEIJPtMcQr`,
	"illustrationMobile": `PqNT7LzORlWo3h`,
	"illustration": `het1dLkVUEO4Uc`,
	"profileInformation": `x6MwT_YZVsPfjQ`,
	"atlassianProfileName": `Gk1talRmKh95u9`,
	"atlassianProfileEmail": `Tjk6uv5GGaoP5f`,
	"avatar": `ZjbAUhrBh9a8qm`,
	"atlassianProfileAvatar": `XTC4dX1AY2uRjd`,
	"buttonSection": `uf0TiaJ47xu0YV`,
	"spinner": `D6W4EGdpMVoEYI`
};
export default ___CSS_LOADER_EXPORT___;
